(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/accountservices-react/deposit/assets/react/swish/components/swish-outage.js') >= 0) return;  svs.modules.push('/components/accountservices-react/deposit/assets/react/swish/components/swish-outage.js');

'use strict';

const {
  useEffect,
  useState
} = React;
const {
  subscribe,
  unsubscribe
} = svs.accountservicesReact.deposit.services.swishSocket;
const {
  paymentTypes
} = svs.accountservicesReact.deposit.constants;
const Button = svs.ui.ReactButton;
const {
  makeMessage,
  makeOutageMessage
} = svs.accountservicesReact.deposit.helpers.swishOutageHelpers;
const initialMessages = {
  swish: makeOutageMessage('Swish', true, 'Visa andra insättningsmetoder', () => {}),
  nordea: makeOutageMessage('Nordea', false),
  sss: makeOutageMessage('Swedbank, SEB och Skandiabanken', false),
  bankId: makeMessage('BankId', 'Välj Apple Pay istället om BankID inte fungerar.', true, 'Byt till Apple pay', () => {}),
  maintenanceSwish: makeMessage(_, _, true, () => {}),
  maintenaceBank: makeMessage()
};
const SwishOutage = _ref => {
  let {
    handleSelect
  } = _ref;
  const [code, setCode] = useState('swish');
  const [messages, setMessages] = useState({
    swish: {}
  });
  const [isSwishOutage, setIsSwishOutage] = useState(false);
  useEffect(() => {
    subscribe(swishData => {
      const isSwishOk = swishData === null || swishData === void 0 ? void 0 : swishData.swishIsOk;
      setIsSwishOutage(!isSwishOk);
      if (isSwishOk) {
        return;
      }
      setCode('swish');
    });
    return unsubscribe(() => {
    });
  }, []);
  useEffect(() => {
    initialMessages.bankId.handleClick = () => handleSelect(paymentTypes.APPLEPAY);
    initialMessages.swish.handleClick = () => {
      handleSelect('open');
    };
    setMessages(initialMessages);
  }, []);
  const {
    title,
    message,
    handleClick,
    buttonText,
    isButton
  } = messages[code];
  return (
    React.createElement(React.Fragment, null, isSwishOutage && React.createElement("div", {
      className: "margin-top-2 padding-1 u-border-radius-6 bg-tur-100"
    }, React.createElement("h3", {
      className: "h4 margin-bottom-1"
    }, title), React.createElement("p", null, message), isButton && React.createElement("div", null, React.createElement(Button, {
      block: true,
      onClick: handleClick,
      transparent: true
    }, buttonText))))
  );
};
svs.accountservicesReact.deposit.swish.components.SwishOutage = SwishOutage;

 })(window);